
const TrainingFormat = () => {
  return (
    <div className="bg-gradient-to-br from-white to-kaija-sage/30 p-8 rounded-lg border border-gray-200 shadow-sm mb-14 hover:shadow-md transition-shadow duration-300">
      <h2 className="text-2xl font-medium mb-4 text-center">Koolituse vorm ja kestus</h2>
      <p className="text-gray-700 mb-0 leading-relaxed">
        Koolitus toimub paindlikult – ühepäevase koolitusena või jaotatuna mitmeks osaks. Võib valida täiskursuse või ainult spetsiifilised osad vastavalt vajadustele. Koolituse sagedust ja vormi saab kohandada vastavalt ettevõtte vajadustele ja soovidele. Saadaval nii veebi teel kui kohapeal.
      </p>
    </div>
  );
};

export default TrainingFormat;
